import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';
import { KeycloakUserService } from 'src/app/shared/user/keycloak-user.service';
import { WhiteLabelConfigService } from 'src/app/white-label/white-label-config.service';
import { environment } from 'src/environments/environment';
import { I18nService } from 'src/app/i18n/i18n.service';
import { WhiteLabelService } from 'src/app/white-label/white-label.service';
import { ChangePasswordModalService } from 'src/app/common-logic/users/change-password/change-password-modal.service';

@Component({
  selector: 'app-user-inner',
  styleUrls: ['./user-inner.component.scss'],
  templateUrl: './user-inner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserInnerComponent {
  @HostBinding('class')
  public readonly class = 'menu menu-sub menu-sub-dropdown menu-column menu-dark menu-state-bg menu-state-primary fw-bold py-3 fs-6 w-275px';

  @HostBinding('attr.data-kt-menu')
  public dataKtMenu = 'true';

  public language: LanguageFlag;

  public readonly i18nService: I18nService;
  public readonly whiteLabelService: WhiteLabelService;
  public readonly whiteLabelConfigService: WhiteLabelConfigService;
  private readonly keycloakUserService: KeycloakUserService;
  private readonly changePasswordModalService: ChangePasswordModalService;

  constructor() {
    this.i18nService = inject(I18nService);
    this.whiteLabelService = inject(WhiteLabelService);
    this.whiteLabelConfigService = inject(WhiteLabelConfigService);
    this.keycloakUserService = inject(KeycloakUserService);
    this.changePasswordModalService = inject(ChangePasswordModalService);
  }

  public get user$() {
    return this.keycloakUserService.getUser();
  }

  public changePassword(): void {
    this.changePasswordModalService.open();
  }

  public logout(): void {
    this.keycloakUserService.logout(
      this.whiteLabelConfigService.isWhiteLabelContext
        ? this.whiteLabelConfigService.logoutRedirectUrl
        : environment.appLandingPage
    );
  }
}

interface LanguageFlag {
  lang: string;
  name: string;
  flag: string;
  active?: boolean;
}
